import { render, staticRenderFns } from "./CallLogTypeCreate.vue?vue&type=template&id=fbfb9a8a&scoped=true&"
import script from "./CallLogTypeCreate.vue?vue&type=script&lang=js&"
export * from "./CallLogTypeCreate.vue?vue&type=script&lang=js&"
import style0 from "./CallLogTypeCreate.vue?vue&type=style&index=0&id=fbfb9a8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfb9a8a",
  null
  
)

export default component.exports